import tabs from "../../../utils/tabs/tab.js";

const redeem = () => {
  const checkBoxes = [...document.querySelectorAll("[data-card-check]")];
  const rewardContainer = document.getElementById("reward-container");
  const continueBtn = document.getElementById("continue-btn");
  const rewardPoints = document.getElementById("reward-points");
  const gridAnimation = document.getElementById("grid-animation");
  const tabElements = [...document.querySelectorAll("[data-tab]")];
  console.log("tabelements", tabElements);

  tabs();

  const checkBoxLogic = (animation) => {
    const checkBoxes = [...document.querySelectorAll("[data-card-check]")];
    const isAnyChecked = checkBoxes.some((element) => element.checked);
    isAnyChecked
      ? (rewardContainer.parentElement.classList.add("js-active"),
        continueBtn?.classList.remove("disabled"))
      : (rewardContainer.parentElement.classList.remove("js-active"),
        continueBtn?.classList.add("disabled"),
        gridAnimation.classList.remove("js-active"));
  };

  tabElements.forEach((tab) => {
    tab.addEventListener("click", function () {
      if (this.getAttribute("data-tab") === "histroy") {
        gridAnimation.classList.remove("js-active");
      } else {
        checkBoxLogic("add-animation");
      }
    });
  });

  checkBoxes.forEach((element) => {
    element.addEventListener("change", (e) => {
      checkBoxLogic();
      if (e.target.checked) {
        const checkedPoint = parseFloat(
          document.querySelector(
            `[data-redeem-point=${e.target.getAttribute("data-card-check")}]`
          ).textContent
        );
        console.log(parseFloat(rewardPoints.textContent), checkedPoint);
        rewardPoints.textContent =(
          parseFloat(rewardPoints.textContent) + checkedPoint).toFixed(2);
      } else {
        const checkedPoint = parseFloat(
          document.querySelector(
            `[data-redeem-point=${e.target.getAttribute("data-card-check")}]`
          ).textContent
        );
        rewardPoints.textContent =(
          parseFloat(rewardPoints.textContent) - checkedPoint).toFixed(2);
      }
    });
  });

  continueBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    gridAnimation.classList.add("js-active");

    let destination = document.querySelector(this.hash);
    // destination.scrollIntoView({
    //   behavior: "smooth",
    //   block: 'start'
    // });
    if (destination) {
        const offset = 4000 // Adjust this value for your header height or desired spacing
        console.log('element',destination.getBoundingClientRect(), window.scrollY)
        const elementPosition = destination.getBoundingClientRect().top;
        const offsetPosition = (elementPosition + window.scrollY) + offset;
    
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
  });
};

export default redeem;
